// extracted by mini-css-extract-plugin
module.exports = {"hidemobile":"index-module--hidemobile--oLEP1","content":"index-module--content--Z2ABQ"};